import { FilterMap, Filters, Platform } from '~/screens/MyAgency/types';

export const getValidFilterTypes = (filter: Filters) => {
  return [
    filter.filterType,
    filter.filterType.includes('Criteria')
      ? null
      : `${filter.filterType}Criteria`,
  ].filter((type) => type !== null) as (keyof FilterMap[Platform])[];
};
